// extracted by mini-css-extract-plugin
export default {"title":"_02Resume_title__OjUXX","extraContent":"_02Resume_extraContent__ArN1Q"};